
import { CustomQualityControlDto, CreateCustomQualityControlDto, UpdateCustomQualityControlDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { customQualityControlService, CustomQualityControlsFilters } from '@services/customQualityControlService'

const { reducer, actions, thunks } = baseCrudReducer<
  CustomQualityControlDto,
  CreateCustomQualityControlDto,
  UpdateCustomQualityControlDto,
  CustomQualityControlsFilters
>('customQualityControl', customQualityControlService)

export default reducer

export const { setFilters: setCustomQualityControlFilters } = actions

export const {
  getAll: getCustomQualityControls,
  create: createCustomQualityControl,
  update: updateCustomQualityControl,
  remove: removeCustomQualityControl,
} = thunks
